import { Box, Checkbox, Group, useMantineTheme } from '@mantine/core';
import ItemIcon, { type ItemIconType } from '@repo/common/components/ItemIcon';
import type { SelectablePropertyItem } from '@repo/common/components/SingleSelector/types';
import { Text } from '@repo/foundations';

interface ActionCheckboxProps {
	item: SelectablePropertyItem;
	handleTrigger: (value: string | boolean) => void;
	state: 'checked' | 'unchecked' | 'indeterminate';
	iconType?: ItemIconType;
}

export function ActionCheckbox({
	item,
	handleTrigger,
	state,
	iconType = 'none',
}: ActionCheckboxProps) {
	const theme = useMantineTheme();

	return (
		<Box
			py="xs"
			px={'sm'}
			sx={{
				display: 'flex',
				alignItems: 'center',
				gap: theme.spacing.sm,
				width: '100%',
				minHeight: theme.other.space[8],
				borderRadius: theme.radius.sm,
				border: 'none',
				background: 'none',
				color: 'inherit',
				cursor: 'pointer',
				textAlign: 'left',
				':hover': {
					backgroundColor: theme.other.getColor('surface/primary/hover'),
				},
			}}
			component="button"
			onClick={() => handleTrigger(item.value)}
		>
			<Checkbox
				indeterminate={state === 'indeterminate'}
				checked={state === 'checked'}
			/>
			<Group spacing="xs" noWrap sx={{ minWidth: 0 }}>
				<ItemIcon type={iconType} item={item} />
				<Text size="sm" color="text/primary/default" lineClamp={1}>
					{item.label}
				</Text>
			</Group>
		</Box>
	);
}
